import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { StateService, TransitionService } from '@uirouter/angularjs';
import { CurrentUserService } from 'services/currentUser';
import * as _ from 'lodash';
import { capitalizeWords } from 'common/source/utilities/strings';
import { getActionableCustomerPolicyInfos } from 'utilities/policyInfosHelper';

const module = angular.module('address-selector', []);

interface AddressSelectorController extends angular.IStrictController {
    active: boolean;
    toggle(): void;
    onBlur(): void;
    close(): void;
    selectPolicy($index: RoutePolicyIndex): void;
    onKeyUp(event: JQueryEventObject): void;
    currentPolicyIndex?: RoutePolicyIndex;
    policyInfos: Array<{ street: string; $policyIndex: RoutePolicyIndex }>;
    currentPolicy?: { street: string };
    focusedPolicyIndex: ArrayPolicyIndex;
}

module.component('addressSelector', {
    template: template,
    controller: function(
        this: AddressSelectorController,
        $timeout,
        $element,
        $transitions: TransitionService,
        currentUserService: CurrentUserService,
        $state: StateService
    ) {
        'ngInject';

        $transitions.onStart({}, (transition) => {
            this.currentPolicyIndex = undefined;

            if (typeof transition.params().policyIndex !== 'undefined') {
                this.currentPolicyIndex = transition.params().policyIndex;
            }

            this.active = false;
            this.policyInfos = [];

            currentUserService.getDisplayOrderedCustomerPolicyInfos().then((policyInfos) => {
                const customerPolicyInfosWithIndexes = currentUserService.getIndexedCustomerPolicyInfos(policyInfos);
                const actionableCustomerPolicyInfos = getActionableCustomerPolicyInfos(customerPolicyInfosWithIndexes);
                this.policyInfos = actionableCustomerPolicyInfos.map((policyInfo) => {
                    return {
                        street: capitalizeWords(policyInfo.property_data.address.street),
                        $policyIndex: policyInfo.$policyIndex
                    };
                });

                if (this.currentPolicyIndex !== undefined) {
                    currentUserService.getCustomerPolicyInfoByIndex(this.currentPolicyIndex).then((policyInfo) => {
                        this.currentPolicy = {
                            street: capitalizeWords(policyInfo.property_data.address.street)
                        };
                    });
                }
            });
        });

        this.toggle = () => {
            if (this.policyInfos.length > 1) {
                this.active = !this.active;

                if (this.active) {
                    // we're opening it
                    this.focusedPolicyIndex = 0 as ArrayPolicyIndex;
                }
            }
        };

        this.close = () => {
            this.active = false;
        };

        this.selectPolicy = ($index: RoutePolicyIndex) => {
            this.currentPolicy = _.find(this.policyInfos, (policyInfo) => {
                return $index === policyInfo.$policyIndex;
            });

            $state.go('overview', {
                policyIndex: $index
            });

            this.close();
        };

        this.onKeyUp = (event: JQueryEventObject) => {
            if (event.keyCode !== 38 && event.keyCode !== 40 && event.keyCode !== 27) {
                return;
            }

            const focusedPolicyIndex = this.focusedPolicyIndex;
            const numberOfPolicies = this.policyInfos.length;

            let nextPolicyIndex = 0 as ArrayPolicyIndex;

            if (event.keyCode === 27) {
                // Handle escape
                this.close();
            } else if (event.keyCode === 40) {
                // Handle down
                const isLastPolicy = focusedPolicyIndex + 1 === numberOfPolicies;

                if (isLastPolicy) {
                    nextPolicyIndex = 0 as ArrayPolicyIndex;
                } else {
                    nextPolicyIndex = (focusedPolicyIndex + 1) as ArrayPolicyIndex;
                }
            } else if (event.keyCode === 38) {
                // Handle up
                const isFirstPolicy = focusedPolicyIndex === 0;
                const lastPolicyIndex = numberOfPolicies - 1;

                nextPolicyIndex = (isFirstPolicy ? lastPolicyIndex : focusedPolicyIndex - 1) as ArrayPolicyIndex;
            }

            this.focusedPolicyIndex = nextPolicyIndex;

            $element
                .find('a')
                .eq(nextPolicyIndex)[0]
                .focus();
        };

        this.onBlur = () => {
            if (this.policyInfos.length > 1) {
                $timeout(() => {
                    const focusedElement = document.activeElement;

                    if (
                        !focusedElement ||
                        (!focusedElement.classList.contains('address') &&
                            !focusedElement.classList.contains('dropdown-list-item') &&
                            !focusedElement.classList.contains('dropdown'))
                    ) {
                        this.close();
                    }
                });
            }
        };
    }
});

export { module };
